/* eslint-disable react-hooks/exhaustive-deps */
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Close } from "@mui/icons-material";
import { format } from "date-fns";

import messages from "../../../../utils/messages";
import serviceRebateUsina from "@/services/serviceRebateUsina";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    data: {
        open: boolean;
        rebateID: string;
    };
    onClose?: any;
}

export default function DialogError({ open, data, onClose, onSuccess }: IDialogProps) {
    const [listErros, setListErros] = useState<any>();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const getErros = async (id: string) => {
        setIsLoading(true);

        serviceRebateUsina
            .getListaErros(id)
            .then((result) => {
                setListErros(result.data);
                onSuccess();
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        if (open) {
            getErros(data.rebateID);
        }
    }, [open]);

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <DialogTitle>
                Erros Rebate ID: {data.rebateID}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                    }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Box>
                    {isLoading ? (
                        <Box
                            style={{ display: "flex", height: "80px", justifyContent: "center", alignItems: "center" }}
                        >
                            <CircularProgress />
                        </Box>
                    ) : (
                        <ul>
                            {listErros && listErros.length > 0 ? (
                                listErros.map((item, index) => {
                                    return (
                                        <li key={index}>
                                            <Typography>
                                                ID: {item.rebateUsinaInstalacaoID} -
                                                {format(
                                                    new Date(item.dataHoraUltimaAtualizacao.slice(0, 10)),
                                                    "dd/MM/yyyy"
                                                )}
                                                - {item.descricao}
                                            </Typography>
                                        </li>
                                    );
                                })
                            ) : (
                                <Typography>"Nenhum erro encontrado"</Typography>
                            )}
                        </ul>
                    )}
                </Box>
            </DialogContent>
            <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                <Button
                    onClick={onClose}
                    color="warning"
                    variant="contained"
                    style={{ width: "159px", height: "44px" }}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
}
